<template>
  <div>
    <div class="content">
      <div v-for="(item, index) in content_list" :key="item.uid">
        <div class="textareaBox" v-if="item.annex_type == 3">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="item.annex_content"
            @input="changeinput"
            show-word-limit
            maxlength="500"
          >
          </el-input>
          <i class="el-icon-error close" @click="del(index, item)"></i>
        </div>
        <div class="commonbox imgbox" v-if="item.annex_type == 1">
          <img :src="item.url" alt="" />
          <i class="el-icon-error close" @click="del(index, item)"></i>
          <i class="el-icon-zoom-in big" @click="play(item, item)"></i>
        </div>
        <div class="commonbox videobox" v-if="item.annex_type == 2">
          <video :src="item.url"></video>
          <i class="el-icon-error close" @click="del(index, item)"></i>
          <i class="el-icon-zoom-in big" @click="play(item)"></i>
        </div>
        <!-- 曲谱 -->
        <div class="commonbox opernbox" v-if="item.annex_type == 5">
          <div class="flex opern-title">
            <div class="title-text">{{ item.name }}</div>
            <i class="el-icon-error close" @click="del(index, item)"></i>
          </div>
          <div class="flex opern-content">
            <div class="flex content-info">
              <div class="flex">
                <span>{{ item.instrument || "-" }}</span>
              </div>
              <div class="content-border"></div>
              <div class="flex">
                <span>{{ item.singer || "-" }}</span>
              </div>
              <div class="content-border" v-show="item.tonality"></div>
              <div v-show="item.tonality">{{ item.tonality }}</div>
            </div>
            <div class="content-view" @click="handleSheetPreview(item)">
              预览
            </div>
          </div>
        </div>
        <template v-if="item.annex_type == 4">
          <audioPlay
            :audioItem="item"
            :idx="index"
            @del="del(index, item)"
          ></audioPlay>
        </template>
      </div>
    </div>
    <div class="contentbottom">
      <div class="chooseType">
        <teaching-material @change="handleAddHomework">
          <div class="chooseIcon text">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/homework/book.png"
              alt=""
            />
            <span>教材</span>
          </div>
        </teaching-material>
        <div class="chooseIcon" @click="addText">
          <img
            src="https://wowsite.musicwow.com/teaching_system_frontend/images/homework/videoicon.png"
            alt=""
          />
          <span>文字</span>
        </div>
        <el-upload
          class="avatar-uploaderimg"
          action=""
          ref="imgUpload"
          :http-request="chooseImg"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          accept="image/*"
          :limit="9"
          multiple
          :on-exceed="exceedClick"
          v-loading="imgLoading"
        >
          <div class="chooseIcon img">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/homework/imgicon.png"
              alt=""
            />
            <span>图片</span>
          </div>
        </el-upload>
        <el-upload
          class="avatar-uploaderimg"
          action=""
          ref="musicUpload"
          :http-request="chooseMusic"
          :show-file-list="false"
          :before-upload="beforeMusicUpload"
          accept=".mp3,.wav,.flac"
          :limit="9"
          multiple
          v-loading="audioLoading"
          :on-exceed="exceedClick"
        >
          <div class="chooseIcon">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/homework/music.png"
              alt=""
            />
            <span>音频</span>
          </div>
        </el-upload>
        <el-upload
          class="avatar-uploaderimg"
          action=""
          ref="videoUpload"
          :http-request="chooseVideo"
          :show-file-list="false"
          :before-upload="beforeVideoUpload"
          v-loading="loading"
          accept="video/*"
          :limit="9"
          multiple
          :on-exceed="exceedClick"
        >
          <div class="chooseIcon">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/homework/texticon.png"
              alt=""
            />
            <span>视频</span>
          </div>
        </el-upload>
        <div class="avatar-uploaderimg" @click="handleLinkOpern">
          <div class="chooseIcon">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/homework/opern.png"
              alt=""
            />
            <span>曲谱</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
      <img :src="dialogImageUrl" class="bigimg" alt="" />
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVideo"
      :modal-append-to-body="false"
      destroy-on-close
    >
      <video :src="dialogVideoUrl" class="bigimg" controls></video>
    </el-dialog>
    <!-- 曲谱选择 -->
    <opern-dialog
      :visible.sync="opernDialogVisible"
      @change="handleOpernChange"
      :selected="selectrdSheet"
    ></opern-dialog>
    <!-- 曲谱预览 -->
    <el-dialog
      :title="sheetPreviewDialogTitle + '预览'"
      :visible.sync="sheetPreviewDialogVisible"
      width="290px"
    >
      <sheet-preview-dialog
        :music-id="sheetPreviewDialogId"
      ></sheet-preview-dialog>
      <p
        style="
          text-align: center;
          font-size: 14px;
          color: #333;
          margin-top: 12px;
        "
      >
        请使用音乐窝APP扫码预览
      </p>
    </el-dialog>
  </div>
</template>
<script>
import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";
import audioPlay from "./audioPlay.vue";
import teachingMaterial from "./teachingMaterial.vue";
import opernDialog from "./opernDialog.vue";
import sheetPreviewDialog from "./sheetPreviewDialog.vue";
export default {
  name: "uploadBox",
  components: {
    audioPlay,
    teachingMaterial,
    opernDialog,
    sheetPreviewDialog,
  },
  data() {
    return {
      client: null,
      prefix: "",
      cdn_url: "",
      callback: {},
      piclist: [],
      disabled: false,
      dialogVisible: false,
      dialogVideo: false,
      dialogImageUrl: "",
      dialogVideoUrl: "",
      textarea: "",
      progressNumber: 0,
      loading: false,
      imgLoading: false,
      audioLoading: false,
      opernLoading: false,
      content_list: [
        // {
        //   annex_type: 5,
        // },
      ],
      videoUrl: [],
      musicUrl: [],
      opernDialogVisible: false,
      sheetPreviewDialogVisible: false,
      sheetPreviewDialogId: "",
      sheetPreviewDialogTitle: "",
    };
  },
  computed: {
    selectrdSheet() {
      return this.content_list
        .filter((item) => {
          return item.annex_type === 5;
        })
        .map((it) => {
          return Number(it.annex_content);
        });
    },
  },
  created() {
    this.addText();
  },
  methods: {
    addText() {
      const _t = this;
      _t.content_list.push({ annex_type: 3, annex_content: "" });
    },
    changeinput() {
      const _t = this;
      _t.setData();
    },
    exceedClick(e) {
      this.$message({
        type: "error",
        message: "最多只上传9个!",
      });
    },
    play(e) {
      const _t = this;
      if (e.annex_type == 1) {
        _t.dialogImageUrl = e.url;
        _t.dialogVisible = true;
      } else if (e.annex_type == 2) {
        _t.dialogVideoUrl = e.url;
        _t.dialogVideo = true;
      }
    },
    del(e, item) {
      const _t = this;
      if (item.annex_type == 1) {
        const pictureUploadList = _t.$refs.imgUpload.uploadFiles;
        pictureUploadList.forEach((a, b) => {
          if (a.uid == item.uid) {
            pictureUploadList.splice(b, 1);
          }
        });
      } else if (item.annex_type == 2) {
        const videoUploadList = _t.$refs.videoUpload.uploadFiles;
        videoUploadList.forEach((a, b) => {
          if (a.uid == item.uid) {
            videoUploadList.splice(b, 1);
          }
        });
      } else if (item.annex_type == 4) {
        const musicUploadList = _t.$refs.musicUpload.uploadFiles;
        musicUploadList.forEach((a, b) => {
          if (a.uid == item.uid) {
            musicUploadList.splice(b, 1);
          }
        });
      }
      _t.content_list.splice(e, 1);
      _t.setData();
    },
    handleAddHomework(data) {
      data.content_list.map((item) => {
        item.url = item.annex_content;
      });
      this.content_list = [...this.content_list, ...data.content_list];
      this.setData();
    },
    setData() {
      const _t = this;
      let content_list = [];
      content_list = _t.content_list.map((a, b) => {
        a.sort = b;
        return a;
      });
      _t.$emit("setContentList", content_list);
    },
    chooseImg(e) {
      const self = this;
      getOSSConfig().then((res) => {
        // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
        // 不同上传请求则需要每次重新获取token
        if (res.error_code == 0) {
          self.prefix = res.data.object_name_prefix;
          self.cdn_url = res.data.cdn_url;
          self.callback = res.data.callback;
          self.client = new OSS({
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            stsToken: res.data.security_token,
            region: "oss-cn-shenzhen",
            bucket: res.data.bucket,
          });
          const progress = (p, _checkpoint) => {
            self.progressNumber = Math.floor(p * 100);
          };
          self.imgLoading = true;
          self.client
            .put(self.prefix + e.file.name, e.file, {
              callback: {
                url: self.callback.callback_url,
                host: self.callback.callback_host,
                body: self.callback.callback_body,
                contentType: self.callback.callback_body_type,
              },
              progress,
            })
            .then(function (result) {
              if (result.data.code == "Ok") {
                self.imageUrl = self.cdn_url + "/" + result.data.object;
                self.content_list.push({
                  annex_type: 1,
                  annex_content: result.data.object,
                  url: self.imageUrl,
                  uid: e.file.uid,
                });
                // self.$emit("set-img-url", result);
                self.setData();
                self.imgLoading = false;
                self.$message({
                  type: "success",
                  message: "上传成功!",
                });
              }
            })
            .catch(function (err) {
              self.imgLoading = false;
            });
        }
      });
    },
    beforeMusicUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "wav" || testmsg === "flac" || testmsg === "mp3";
      if (!extension) {
        this.$message.error("音频上传格式支持wav、falc、mp3；其他不支持");
        return false;
      }
      return true;
    },
    beforeAvatarUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "jpeg" ||
        testmsg === "JPEG";
      if (!extension) {
        this.$message.error("图片上传格式支持jpeg、jpg、png；其他不支持");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 15;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 15MB!");
      }
      return isLt2M;
    },
    beforeVideoUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "MP4" ||
        testmsg === "mp4" ||
        testmsg === "mov" ||
        testmsg === "MOV";
      if (!extension) {
        this.$message.error("视频上传格式支持MP4、mov；其他不支持");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 500;
      if (!isLt2M) {
        this.$message.error("上传视频大小不能超过 500MB!");
        return false;
      }
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    chooseVideo(e) {
      const self = this;
      getOSSConfig().then(async (res) => {
        // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
        // 不同上传请求则需要每次重新获取token
        if (res.error_code == 0) {
          self.cdn_url = res.data.cdn_url;
          const client = new OSS({
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            stsToken: res.data.security_token,
            region: "oss-cn-shenzhen",
            bucket: res.data.bucket,
          });
          const progress = (p, _checkpoint) => {
            self.progressNumber = Math.floor(p * 100);
          };
          self.loading = true;
          try {
            // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
            const fname = res.data.object_name_prefix + e.file.name;
            const result = await client.multipartUpload(fname, e.file, {
              callback: {
                url: res.data.callback.callback_url,
                host: res.data.callback.callback_host,
                body: res.data.callback.callback_body,
                contentType: res.data.callback.callback_body_type,
              },
              progress,
              // partSize: 50*1024*1024,
              // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
              meta: {},
            });
            const head = await client.head(result.data.object);
            if (result.data.code == "Ok") {
              self.videoUrl = self.cdn_url + "/" + result.data.object;
              self.content_list.push({
                annex_type: 2,
                annex_content: result.data.object,
                url: self.videoUrl,
                uid: e.file.uid,
              });
              self.setData();
              self.$message({
                type: "success",
                message: "上传成功!",
              });
            } else {
              self.$message({
                type: "error",
                message: "上传失败",
              });
            }
            self.loading = false;
          } catch (e) {
            // 捕获超时异常。
            // console.log("TimeoutError");
            self.$message({
              type: "error",
              message: "上传超时",
            });
            // do ConnectionTimeoutError operation
            self.loading = false;
          }
        }
      });
    },
    chooseMusic(e) {
      const self = this;
      getOSSConfig().then(async (res) => {
        // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
        // 不同上传请求则需要每次重新获取token
        if (res.error_code == 0) {
          self.cdn_url = res.data.cdn_url;
          const client = new OSS({
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            stsToken: res.data.security_token,
            region: "oss-cn-shenzhen",
            bucket: res.data.bucket,
          });
          const progress = (p, _checkpoint) => {
            self.progressNumber = Math.floor(p * 100);
          };
          self.audioLoading = true;
          try {
            // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
            const fname = res.data.object_name_prefix + e.file.name;
            const result = await client.multipartUpload(fname, e.file, {
              callback: {
                url: res.data.callback.callback_url,
                host: res.data.callback.callback_host,
                body: res.data.callback.callback_body,
                contentType: res.data.callback.callback_body_type,
              },
              progress,
              // partSize: 50*1024*1024,
              // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
              meta: {},
            });
            const head = await client.head(result.data.object);
            // console.log(head);
            if (result.data.code == "Ok") {
              self.musicUrl = self.cdn_url + "/" + result.data.object;
              self.content_list.push({
                annex_type: 4,
                annex_content: result.data.object,
                url: self.musicUrl,
                uid: e.file.uid,
              });
              self.setData();
              self.$message({
                type: "success",
                message: "上传成功!",
              });
            } else {
              self.$message({
                type: "error",
                message: "上传失败",
              });
            }
            self.audioLoading = false;
          } catch (e) {
            self.$message({
              type: "error",
              message: "上传超时",
            });
            self.audioLoading = false;
          }
        }
      });
    },

    // // 上传曲谱
    // beforeOpernUpload(file) {
    //   const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
    //   const extension =
    //     testmsg === "jpg" ||
    //     testmsg === "JPG" ||
    //     testmsg === "png" ||
    //     testmsg === "PNG" ||
    //     testmsg === "jpeg" ||
    //     testmsg === "JPEG";
    //   if (!extension) {
    //     this.$message.error("图片上传格式支持jpeg、jpg、png；其他不支持");
    //     return false;
    //   }
    //   const isLt2M = file.size / 1024 / 1024 < 15;
    //   if (!isLt2M) {
    //     this.$message.error("上传图片大小不能超过 15MB!");
    //   }
    //   return isLt2M;
    // },
    // // 选择曲谱
    // chooseOpern(e) {
    //   const self = this;
    //   getOSSConfig().then(async (res) => {
    //     // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
    //     // 不同上传请求则需要每次重新获取token
    //     if (res.error_code == 0) {
    //       self.cdn_url = res.data.cdn_url;
    //       const client = new OSS({
    //         accessKeyId: res.data.access_key_id,
    //         accessKeySecret: res.data.access_key_secret,
    //         stsToken: res.data.security_token,
    //         region: "oss-cn-shenzhen",
    //         bucket: res.data.bucket,
    //       });
    //       const progress = (p, _checkpoint) => {
    //         self.progressNumber = Math.floor(p * 100);
    //       };
    //       self.opernLoading = true;
    //       try {
    //         // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
    //         const fname = res.data.object_name_prefix + e.file.name;
    //         const result = await client.multipartUpload(fname, e.file, {
    //           callback: {
    //             url: res.data.callback.callback_url,
    //             host: res.data.callback.callback_host,
    //             body: res.data.callback.callback_body,
    //             contentType: res.data.callback.callback_body_type,
    //           },
    //           progress,
    //           // partSize: 50*1024*1024,
    //           // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
    //           meta: {},
    //         });
    //         const head = await client.head(result.data.object);
    //         if (result.data.code == "Ok") {
    //           self.videoUrl = self.cdn_url + "/" + result.data.object;
    //           self.content_list.push({
    //             annex_type: 5,
    //             annex_content: result.data.object,
    //             url: self.videoUrl,
    //             uid: e.file.uid,
    //           });
    //           self.setData();
    //           self.$message({
    //             type: "success",
    //             message: "上传成功!",
    //           });
    //         } else {
    //           self.$message({
    //             type: "error",
    //             message: "上传失败",
    //           });
    //         }
    //         self.opernLoading = false;
    //       } catch (e) {
    //         // 捕获超时异常。
    //         // console.log("TimeoutError");
    //         self.$message({
    //           type: "error",
    //           message: "上传超时",
    //         });
    //         // do ConnectionTimeoutError operation
    //         self.opernLoading = false;
    //       }
    //     }
    //   });
    // },
    // 关联曲谱
    handleLinkOpern() {
      this.opernDialogVisible = true;
    },
    handleOpernChange(arr) {
      arr.map((item) => {
        this.content_list.push({
          annex_type: 5,
          annex_content: item.music_id,
          sort: 0,
          name: item.name,
          instrument: item.instrument_list
            .map((item) => {
              return item.name;
            })
            .join(","),
          singer: item.singer_list
            .map((item) => {
              return item.name;
            })
            .join(","),
          tonality: item.tonality,
        });
      });
      this.setData();
    },
    handleSheetPreview(data) {
      this.sheetPreviewDialogId = data.annex_content;
      this.sheetPreviewDialogVisible = true;
      this.sheetPreviewDialogTitle = data.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.contentbottom {
  margin-bottom: 16px;
}
.bigimg {
  max-width: 100%;
  max-height: 80vh;
  margin: 0 auto;
  display: block;
}
.content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .textareaBox {
    position: relative;
    width: 378px;
    display: inline-block;
    margin-right: 42px;
    .close {
      position: absolute;
      right: 3px;
      top: 3px;
      font-size: 16px;
      color: #d8d8d8;
      cursor: pointer;
    }
    .el-textarea {
      /deep/.el-textarea__inner {
        height: 80px;
        margin-bottom: 16px !important;
      }
      /deep/ .el-input__count {
        bottom: 20px;
      }
    }
  }
}
.el-upload:hover {
  border-color: #409eff;
}
.avatarBox {
  position: relative;
  .hover {
    position: absolute;
    left: 0;
    top: 0;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 20px;
  }
}
.avatarBox:hover .hover {
  display: block;
}
.commonbox {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #e1e5e9;
  margin-right: 16px;
  display: inline-block;
  margin-right: 42px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  img {
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 3px;
    top: 3px;
    font-size: 16px;
    color: #d8d8d8;
    cursor: pointer;
    z-index: 2;
  }
  .big {
    font-size: 20px;
    cursor: pointer;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.imgbox:hover .big,
.videobox:hover .big {
  display: flex;
}

.opernbox {
  width: 320px;
  display: block;
  position: relative;
  .close {
    font-size: 16px;
    color: #d8d8d8;
    cursor: pointer;
  }
  .opern-title {
    margin: 14px 13px;
    line-height: 2;
    .title-text {
      flex: 1;
      font-size: 12px;
      color: #5c5d5e;
    }
    .close {
      top: 12px;
      right: 10px;
    }
  }
  .opern-content {
    margin: 10px 13px;
    font-size: 12px;
    color: #adaeae;
    .content-info {
      flex: 1;
    }
    .content-border {
      border-right: 1px solid #adaeae;
      margin: 0 10px;
      height: 12px;
    }
    .content-view {
      position: absolute;
      top: 10px;
      right: 34px;
      padding: 0 8px;
      border-radius: 6px;
      border: 1px solid #45b13b;
      color: #45b13b;
      cursor: pointer;
      margin-left: 10px;
      background-color: #f3fdfa;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
.avatar-uploaderimg {
  border: none;
  /deep/ .el-upload {
    cursor: pointer;
    position: relative;
    border: none !important;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.avatar {
  width: 44px;
  height: 44px;
  display: block;
}
.el-upload_img {
  .el-upload {
    width: 80px;
    height: 80px;
    line-height: 95px;
  }
  li {
    height: 80px;
    width: 80px;
  }
}
.chooseType {
  display: flex;
  padding: 9px;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  width: 360px;
  justify-content: space-between;
  .chooseIcon {
    width: 60px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
    }
    span {
      width: 100%;
      text-align: center;
      font-size: 12px;
      color: #5c5d5e;
      margin-top: 4px;
    }
  }
  .chooseIcon {
    border-left: 1px solid #e1e5e9;
  }
  .chooseIcon.text {
    border: none;
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
